module.exports = __webpack_public_path__ + "media/images/metronic/ajax-modal-loading-eb4e1ef5e8af9145cd3f9176bef3a5bc.gif";